import React from "react"
import { generatePath, useLocation, useNavigate, matchRoutes,
	      useRoutes, useParams, Link, Routes, Route } from "react-router"
import { App } from "App"
import { Radio } from "scenes/Radio/Radio"

export const QlRouterProvider = React.createContext()

let globalRouteStore = null
export class RouteStore {
	routeStoreByName = new Map()
	routeStoreByPath = new Map()
	_arrayCache = null

	constructor() {
		globalRouteStore = this
	}
 
	_getArrayCache() {
		if (this._arrayCache === null) {
			this._arrayCache = Array.from(this.routeStoreByName.values()).map(r => ({
				/*
				path: r.path,
				//element: <r.component />,
				element: r.component,
				type: r.type,
				isDelete: r.isDelete,
				top_menu: r.top_menu,
				search_menu: r.search_menu,
				*/
				...r,
			}))
		}
		return this._arrayCache
	}

	add(name, path, component, vars = {}) {
		const routeDef = { name, path, element: component,  ...vars }
		this.routeStoreByName.set(name, routeDef)
		this.routeStoreByPath.set(path, name)
		this._arrayCache = null
		return this
	}

	renderRoutes(...props) {
		//return <>{renderRoutes(this._getArrayCache(), ...props)}</>
		const cache = this._getArrayCache()
		const routing = useRoutes(cache)
		return routing
	}

	getRouteObject() {
		// "/*" instead of "/" to catch all in useRoutes
		/* MTVW-1061: Radio
		const routeObject = {path: "/*", element: <App />, children : []}
		{this._getArrayCache().map((item, ix) => (
			routeObject.children.push({ path: item.path.replace("/", ""), element: item.element })
		))}
		return routeObject
		*/

		const childRoutes = this._getArrayCache().map((item) => ({
			path: item.path.replace(/^\//, ""),
			element: item.element,
		 }))

		// detect if Radio is already in cache
		const hasRadioRoute = childRoutes.some(
			(r) => r.element?.type?.name === "Radio"
		)

		const routeObject = {
			path: "/*",
			element: <App />, // <App> could contain <Outlet/>, <Radio/> added in QlRouter contains  
			children: hasRadioRoute
			? childRoutes
			: [
				 {
					path: "",
					element: <Radio />, // stays mounted globally
					children: childRoutes,
				 },
			  ],
		}
		//console.debug("routeObject", routeObject)
		return routeObject
	}

	/*
	getRoutes() {
		return (
			<Routes>
			{this._getArrayCache().map((item, ix) => (
				<Route key={ix} path={item.path} element={item.element} />
			))}
			</Routes>
		)
	}
	*/

	matchRoutes(pathname) {
		return matchRoutes(this._getArrayCache(), pathname)
	}

	getVar(pathname, varName, defVal = null) {
		const match = this.matchRoutes(pathname)?.[0].route
		return match?.[varName] ?? match?.name ?? defVal
	}

	getPath(routeName = null, params = null, routeMatch) {
		if (routeName !== null) {
			const route = this.routeStoreByName.get(routeName)
			if (!route) debugger
			return generatePath(route.path, { ...route, ...params })
		}

		const route = this.matchRoutes(routeMatch.pathname) ?? []
		for (let i = 0; i < route?.length; i++) {
			try {
				return generatePath(route[i].match.path, { ...route[i].match.params, ...params })
			} catch (e) {
				console.error("RouteUtils.getPath", e)
				// eslint-disable-next-line no-empty
			}
		}
	}
}

export const useRouteStore = () => {
	return globalRouteStore
	//return React.useContext(QlRouterProvider)
}

export const useRouteLink = () => {
	const routeStore = useRouteStore()
	const routeMatch = useLocation()

	return React.useCallback((routeName = null, params = null) => {
		return routeStore.getPath(routeName, params, routeMatch)
	}, [routeStore, routeMatch]) // eslint-disable-line react-hooks/exhaustive-deps
}

export const useRoutePropsUi = () => {
	const routeLink = useRouteLink()
	return React.useCallback((routeName = null, params = null) => {
		// this would block navigation when clicking on a TopMenu item, but not browser back and forward button presses
		//if (window.location.hash.indexOf("channel-list-editor") >= null) return
		//console.debug("useRoutePropsUi", routeName, params)
		return ({
			to: routeLink(routeName, params),
			component: Link
		})
	}, [routeLink]) // eslint-disable-line react-hooks/exhaustive-deps
}

export const RouteLink = ({ name = null, params = null, children, Component, ...props }) => {
	const routeLink = useRouteLink()
	return (
		<Component to={routeLink(name, params)} component={Link} {...props}>
			{children}
		</Component>
	)
}

export const useNavigateRouteAdd = (route, prop) => {
	const navigate = useNavigate()
	const routeLink = useRouteLink()
	return React.useCallback((routeName = null, params = null) => {
		console.debug("useNavigateRouteAdd.navigate", routeName, params)
		navigate(routeLink(routeName, params))
	}, [navigate, routeLink])
}
